import styled from 'styled-components'

// Selettore valuta a sinistra, importo a destra (vedi CurrencySelector + CurrencyInput)
export const CurrencyInlineRow = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 0.5rem;
  align-items: end;
`
